import { render, staticRenderFns } from "./MarketplaceResourcesComponent.vue?vue&type=template&id=9a606b50&scoped=true"
import script from "./MarketplaceResourcesComponent.vue?vue&type=script&lang=js"
export * from "./MarketplaceResourcesComponent.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceResourcesComponent.vue?vue&type=style&index=0&id=9a606b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a606b50",
  null
  
)

export default component.exports